import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import Swal from 'sweetalert2';

const UserRegistrationForm = () => {
  const { register, handleSubmit, watch, formState: { errors } } = useForm();
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loadingCompanies, setLoadingCompanies] = useState(true);
  const [loadingDepartments, setLoadingDepartments] = useState(true);
  const [error, setError] = useState(null);

  const selectedCompany = watch('company');
  // Base API URL from environment variable
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/companies/get_companies.php`);
        console.log('Companies API response:', response.data); // Log the API response
        if (Array.isArray(response.data)) {
          setCompanies(response.data);
        } else {
          throw new Error("Invalid companies data format");
        }
      } catch (error) {
        console.error('Error fetching companies:', error); // Log the error
        setError(error.message);
      } finally {
        setLoadingCompanies(false);
      }
    };
fetchCompanies();
  }, []);

useEffect(() => {
    console.log('Selected company:', selectedCompany); // Debug log for selected company
    const fetchDepartments = async (companyId) => {
      console.log('fetchDepartments called with companyId:', companyId); // Debug log
      if (!companyId) {
        setDepartments([]);
        return;
      }

      setLoadingDepartments(true);
      try {
        const response = await axios.get(`${API_BASE_URL}/departments/get_departments.php?company_id=${companyId}`);
        console.log('Departments API response:', response.data); // Log the API response
        if (Array.isArray(response.data)) {
          setDepartments(response.data);
        } else {
          throw new Error("Invalid departments data format");
        }
      } catch (error) {
        console.error('Error fetching departments:', error); // Log the error
        setError(error.message);
      } finally {
        setLoadingDepartments(false);
      }
    };

    if (selectedCompany) {
        fetchDepartments(selectedCompany);
      } else {
        setDepartments([]); // Clear departments if no company is selected
      }
  }, [selectedCompany]);

  const onSubmit = async (data) => {
    const { confirmPassword, ...payload } = data;
    try {
      const response = await axios.post(`${API_BASE_URL}/users/register.php`, payload);
      Swal.fire({ icon: 'info', text: response.data.message });
    } catch (error) {
      console.error('There was an error registering the user!', error);
    }
  };

    if (loadingCompanies) {
        return <div>Loading Companies...</div>;
    }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="container mt-4">
    <h2>User Registration</h2>
    <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-3">
            <label className="form-label">Name</label>
            <input type="text" className="form-control" {...register('name')} required />
        </div>
        <div className="mb-3">
            <label className="form-label">Email</label>
            <input type="email" className="form-control" {...register('email')} required />
        </div>
        <div className="mb-3">
            <label className="form-label">IC/Passport No</label>
            <input type="text" className="form-control" {...register('ic_no')} required />
        </div>
        <div className="mb-3">
            <label className="form-label">Company/Subsidiary</label>
            <select className="form-select" {...register('company')} required>
                <option value="">Select a company</option>
                {companies.map(company => (
                    <option key={company.id} value={company.id}>{company.name}</option>
                ))}
            </select>
        </div>
        <div className="mb-3">
            <label className="form-label">Department</label>
            <select className="form-select" {...register('department')} required>
                <option value="">Select a department</option>
                {loadingDepartments ? (
                    <option>Loading...</option>
                ) : (
                    departments.map(department => (
                        <option key={department.id} value={department.id}>{department.name}</option>
                    ))
                )}
            </select>
        </div>
        <div className="mb-3">
            <label className="form-label">Designation</label>
            <input type="text" className="form-control" {...register('designation')} required />
        </div>
        <div className="mb-3">
            <label className="form-label">Employee No.</label>
            <input type="text" className="form-control" {...register('employeeNo')} required />
        </div>
        <div className="mb-3">
            <label className="form-label">Contact No.</label>
            <input type="text" className="form-control" {...register('contactNo')} required />
        </div>
        <div className="mb-3">
            <label className="form-label">Emergency Contact No.</label>
            <input type="text" className="form-control" {...register('emergencyContactNo')} required />
        </div>
        <div className="mb-3">
            <label className="form-label">Relationship</label>
            <input type="text" className="form-control" {...register('relationship')} required />
        </div>
        <div className="mb-3">
            <label className="form-label">Password</label>
            <input type="password" className="form-control" {...register('password')} required />
        </div>
        <div className="mb-3">
            <label className="form-label">Confirm Password</label>
            <input
                type="password"
                className="form-control"
                {...register('confirmPassword', {
                    validate: value => value === watch('password') || 'Passwords do not match',
                })}
                required
            />
            {errors.confirmPassword && (
                <div className="text-danger mt-1">{errors.confirmPassword.message}</div>
            )}
        </div>
        <button type="submit" className="btn btn-primary">Register</button>
    </form>
</div>

    
  );
};

export default UserRegistrationForm;
